var React = require('react');

function People (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.8377 16.064C13.2943 15.5344 14.7283 15.0712 13.62 13.1184C10.2497 7.1768 12.7269 4 16.2866 4C19.9166 4 22.3329 7.2992 18.9523 13.1184C17.8106 15.0824 19.3269 15.5456 21.7311 16.064C23.8594 16.5232 24 17.4936 24 19.1752V20H8.57143C8.57143 17.804 8.38286 16.5936 10.8377 16.064ZM0 20H6.69343C6.66343 13.4584 9.63857 15.7496 9.63857 11.0984C9.63857 9.0896 8.23371 8 6.426 8C3.756 8 1.89857 10.3832 4.42629 14.8392C5.25686 16.3032 3.54257 16.6512 1.69971 17.048C0.103714 17.392 0 18.12 0 19.3816V20Z","fill":"currentColor"}));
}

People.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = People;

People.default = People;
